<template>
	<vxe-grid class="" v-bind="list_gridOptions" v-if="list_gridOptions"
		@toolbar-button-click="list_toolbarButtonClickEvent" :ref="ref">
	</vxe-grid>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			warehouse: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				ref:Math.random(),
				outputmerge: [],
				list_formConfig: [{
					field: 'date',
					title: '时间范围',		
					resetValue:1,		
					itemRender: {
						name: '$select',	
						defaultValue:1,					
						props: {							
							emptyoption:false,
							selectoptions: [{
								value: 1,
								label: '近7天'
							}, {
								value: 2,
								label: '近15天'
							}, {
								value: 3,
								label: '近30天'
							}]
						}
					}
				}],
				list_footerField: [{
					type: 'seq',
					field: 'code',
					title: '汇总',
				}, {
					type: 'field',
					field: 'size',
					toFixed: 0
				}, {
					type: 'field',
					field: 'weight',
					toFixed: 6
				}]

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {


		},
		computed: {

		},

		methods: {
			customreload() {
				this.$refs[this.ref].commitProxy('query')
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.cellStyle = this.cellStyle
				gridOptions.height = 600
				//gridOptions.formConfig.enabled = false
				gridOptions.columns = [{
					type: 'seq',
					title: '#',
					width:50
				},{
					field: 'billCode',
					title: '订单编号'
				}, {
					field: 'size',
					title: '采购数量【个】'
				}, {
					field: 'weight',
					title: '采购重量【kg】'
				}, {
					field: 'status',
					title: '状态',
					formatter:({row})=>{
						if (row.status == 0) {
							return '未到货'
						}
						if (row.status == 1) {
							return '部分到货'
						}
						if (row.status == 2) {
							return '已完成'
						}					
					}
				}, {
					field: 'pregettime',
					title: '预计到货日期',
					formatter:({row})=>{
						return window.systemMethods.timestampToDate(row.pregettime,true)
					}
				}]
			},
			list(page,updateForm,other) {
				return new Promise(resolve => {
					this.$api.warehousepurchase.overtime({
						...page,
						...updateForm,
						...other,
						...{warehouse:this.warehouse}
					}).then((res) => {
						resolve({
							list: res
						})
					}, () => {
						resolve([])
					})
				})
			},
			cellStyle({
				row,
				column
			}) {
				let map = {
					status:{
						0: '#F56C6C',
						1: '#409EFF',
						2: '#67C23A',
					}
				}
				if(map[column.field]){
					return {
						color: map[column.field][row[column.field]]
					}
				}
			
			},

		},
		components: {
			
		}
	}
</script>